import React, { useState } from 'react';

// Constants
const MONTH_NAMES = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

const CalendarHeader = ({ currentDate, onMonthChange }) => {
  const [warning, setWarning] = useState("");

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // First of current displayed month
  const firstOfDisplayed = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  const firstOfCurrent = new Date(today.getFullYear(), today.getMonth(), 1);

  // Calculate last allowed date (end of 3rd month from today)
  const maxAllowedDate = new Date(today.getFullYear(), today.getMonth() + 3, 1);
  maxAllowedDate.setMonth(maxAllowedDate.getMonth() + 1);
  maxAllowedDate.setDate(0); // Last day of that month

  const nextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
  const isNextDisabled = nextMonth > maxAllowedDate;

  const isPreviousDisabled = firstOfDisplayed <= firstOfCurrent;

  const handleMonthChange = (delta) => {
    const newDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + delta, 1);

    if (newDate < firstOfCurrent) {
      return;
    }

    if (newDate > maxAllowedDate) {
      setWarning("Slots are open for up to 3 months from the current date only.");
      return;
    }

    setWarning("");
    onMonthChange(delta);
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-4 bg-warning text-white p-3 rounded">
        <button
          onClick={() => handleMonthChange(-1)}
          type='button'
          disabled={isPreviousDisabled}
          className={`btn btn-sm ${isPreviousDisabled ? 'btn-warning disabled' : 'btn-light text-dark'}`}
          aria-label="Previous month"
        >
          ←
        </button>

        <span className="fw-semibold fs-5">
          {MONTH_NAMES[currentDate.getMonth()]} {currentDate.getFullYear()}
        </span>

        <button
          onClick={() => handleMonthChange(1)}
          type='button'
          className={`btn btn-sm ${isNextDisabled ? 'btn-warning disabled' : 'btn-light text-dark'}`}
          disabled={isNextDisabled}
          aria-label="Next month"
        >
          →
        </button>
      </div>

      {warning && (
        <div className="alert alert-danger py-2 px-3 small mb-3">
          {warning}
        </div>
      )}
    </>
  );
};

export default CalendarHeader;
